import CAMPAIGN_STATE from '@/config/campaignState';
import {ROUTES} from '@/config/routesConstants';
import {CampaignListItem} from '@/hooks/queries/use-campaigns-v2-list-query/useCampaignsV2ListQuery';

export function getCampaignBriefEditUrl(
  campaignId: string,
  generatedByBriefAi: boolean
): string {
  return generatedByBriefAi
    ? `${ROUTES.NEW_CAMPAIGNS}/${campaignId}/brief/edit`
    : `${ROUTES.CAMPAIGNS}/${campaignId}/brief/edit`;
}

export function getCampaignCardUrl(
  campaign: CampaignListItem,
  canEdit = true
): string {
  const {id, state, generatedByBriefAi, newApplicationsCount} = campaign;

  switch (state) {
    case CAMPAIGN_STATE.DRAFT:
    case CAMPAIGN_STATE.UNDER_CONSTRUCTION:
      return canEdit
        ? getCampaignBriefEditUrl(id, generatedByBriefAi)
        : `${ROUTES.CAMPAIGNS_V2}/${id}/brief`;

    case CAMPAIGN_STATE.UNDER_REVIEW:
      return `${ROUTES.CAMPAIGNS_V2}/${id}/brief`;

    case CAMPAIGN_STATE.ACCEPTING_PROPOSALS:
    case CAMPAIGN_STATE.CLOSED_TO_NEW_PROPOSALS:
      if (newApplicationsCount > 0) {
        return `${ROUTES.CAMPAIGNS_V2}/${id}/creators`;
      }

      return `${ROUTES.CAMPAIGNS_V2}/${id}/assets`;

    case CAMPAIGN_STATE.CLOSED:
      return `${ROUTES.CAMPAIGNS_V2}/${id}/statistics`;

    default:
      return `${ROUTES.CAMPAIGNS_V2}/${id}/creators`;
  }
}
